import { render, staticRenderFns } from "./PublicRoleStatus.vue?vue&type=template&id=3281b4fd&"
import script from "./PublicRoleStatus.vue?vue&type=script&lang=ts&"
export * from "./PublicRoleStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports